import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BackendResponse } from '@schenck/rotec-components';
import { Observable } from 'rxjs';
import { Machine } from 'src/utils/interfaces/machine.interfaces';
import { API_BASE_URL } from './tokens';

@Injectable()
export class MachineApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  public machineBaseUrl: string;

  constructor() {
    const baseUrl = this.baseUrl;

    this.machineBaseUrl = baseUrl + '/Machine';
  }

  /**
   * Get available machines
   */
  public get$(): Observable<BackendResponse.Response<Machine[]>> {
    return this.http
      .get<Machine[]>(this.machineBaseUrl + '/Available')
      .pipe(BackendResponse.mapToResponse());
  }

  /**
   * Get machines
   */
  public getMachines$(): Observable<BackendResponse.Response<Machine[]>> {
    return this.http.get<Machine[]>(this.machineBaseUrl).pipe(BackendResponse.mapToResponse());
  }
}
